<template>
  <div>
    <div class="items-list" v-show="isRecommend">
      <template v-for="item in items" :key="item.type">
        <items-swiper v-bind="item" />
      </template>
    </div>
    <game-list ref="gameListRef" v-if="!isRecommend" />
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue';
import ItemsSwiper from './ItemsSwiper.vue';
import { storeToRefs, useGameStore, useHaxiStore, useModalStore, useUserStore } from '@star/stores';
import { filter, map, toNumber } from 'lodash-es';
import { GameBigTypesEnum, GameMainTypesEnum, gameMainTypesMap, ModalTypeEnum } from '@star/constants';
import { getHotGamesData } from '@/plugins/game';
import GameList from './GameList.vue';
import { useI18n } from '@star/languages';
import { getGameImageSrc } from '@star/plugins';
import { usePageLoad } from '@/hooks';

// type Props = {};
// const props = defineProps<Props>();

const modalStore = useModalStore();
const gameStore = useGameStore();
const { gameMainClassList, isLotteryGroupMenu, gameBigClass, newHotGames, activeHomeMainMenuTab } =
  storeToRefs(gameStore);
const { gameList } = storeToRefs(useHaxiStore());
const { isLogin } = storeToRefs(useUserStore());
const { t } = useI18n();
const gameListRef = ref<any>();

// 首页热门游戏
const hotGames = computed(() => {
  const data = getHotGamesData(newHotGames.value);
  return data;
});

// 是否推荐菜单
const isRecommend = computed(() => {
  return toNumber(activeHomeMainMenuTab.value) === GameMainTypesEnum.RECOMMEND;
});

const items = computed(() => {
  let result = map(gameMainClassList.value, item => {
    const key = gameMainTypesMap[item.type];
    return {
      mainType: item.type,
      icon: key,
      path: `/home/${item.type}`,
      title: t(item.play_name),
      maxRows: 1,
      items: map(
        filter(gameBigClass.value?.[key], it => it.state !== 3),
        // filter(gamesData.value[key], it => it.state !== 3),
        it => {
          // console.log(it, '------------------');
          return {
            ...it,
            gameImgUrl: getGameImageSrc(it, { type: key }),
            path: `/home/${item.type}/${it.play_id}`,
            mainType: item.type,
            data: it,
            isPlatform: [
              GameBigTypesEnum.ELECTRONIC,
              GameBigTypesEnum.FISHING,
              GameBigTypesEnum.CHESS,
              GameBigTypesEnum.BLOCK_THIRD,
            ].includes(Number(it.big_type))
              ? true
              : false,
          };
        }
      ),
    };
  });
  if (hotGames.value.length > 0) {
    result.unshift({
      mainType: GameMainTypesEnum.HOT_GAME,
      icon: 'hot',
      path: '',
      title: '热门游戏',
      maxRows: 2,
      items: map(hotGames.value, (item: any, index) => ({
        ...item,
        mainType: GameMainTypesEnum.HOT_GAME,
        gameIndex: index,
      })),
    });
  }

  // 过滤掉试玩
  result = result.filter(e => String(e.mainType) !== String(GameMainTypesEnum.TRIAL));

  console.log(result, 'swiper items data', gameMainClassList.value);
  return result;
});

const getLotteryData = async () => {
  // 彩票数据
  // if (!hallData.value.length || !hallData.value[0]?.[0]) {
  // 彩票大厅数据
  // await gameStore.reqTianChengCp();
  // await gameStore.purchaseHall({
  //   play_cat: 1,
  //   size: 16,
  //   type: 0,
  // });
  // }
};

const init = async () => {
  // await gameStore.getTotalGamesPlatform({ chan_con: getChanCon(), updateNews: true }); // 首页数据
  // if (toNumber(activeHomeMainMenuTab.value) === GameMainTypesEnum.LOTTERY) {
  // await getLotteryData();
  // }
  if (!isRecommend.value) {
    await gameListRef.value?.getGamesData?.();
  }
  setTimeout(() => {
    if (!isLogin.value) {
      modalStore.addPopupModal(ModalTypeEnum.LOGIN_REGISTER_MODAL, { type: 1 });
    }
    modalStore.initModal();
  }, 800);
};

// watch(
//   () => isLotteryGroupMenu.value,
//   value => {
//     if (value) {
//       getLotteryData();
//     }
//   },
//   {
//     immediate: true,
//   }
// );

const pageLoad = usePageLoad(init);

onMounted(async () => {
  await pageLoad.init();
});
</script>

<style lang="less" scoped>
.items-list {
  animation: slide-up 0.4s;
  overflow: hidden;
  padding-top: 12px;
}
</style>
